import { Provider } from "./context";
import { Container } from "./lightbox-container";
import { Item } from "./lightbox-item";

const Lightbox = {
	Provider,
	Item,
	Container,
};

export { Lightbox };
